import styled, { css } from 'styled-components';
import { headLine3, headLine4, para1, readmoreText } from '../theme/GlobalStyle';

export const Title = styled.h3`
  padding: 5px 0 10px;
  color: ${(props) => props.theme.color.textLight};
  ${headLine3}
`;

export const TagButtonGroup = styled.ul`
  display: flex;
  flex-wrap: wrap;
  color: ${(props) => props.theme.color.primary};
  li {
    cursor: pointer;
    a {
      padding: 6px 8px;
      border: 1px solid ${(props) => props.theme.color.primary};
      border-radius: 6px;
      margin: 5px 0;
      display: inline-block;
      outline: none;
      background-color: transparent;
      ${readmoreText}
      color: ${(props) => props.theme.color.bgPrimary};
      transition: all 0.2s ease;
      ${({ secondary }) =>
        secondary &&
        css`
          padding: 8px 10px;
          border: 1px solid ${(props) => props.theme.color.bgPrimary};
        `}
      &.active {
        background-color: ${(props) => props.theme.color.bgPrimary};
        color: ${(props) => props.theme.color.white};
      }
      
      @media (min-width: 1024px) {
        &:hover {
          background-color: ${(props) => props.theme.color.bgPrimary};
          color: ${(props) => props.theme.color.white};
        }
      }
    }
    margin-right: 10px;
  }
  li.tagBtn.active button {
    background-color: ${(props) => props.theme.color.primary};
    color: ${(props) => props.theme.color.white};
  }
  @media (max-width: 824px) {
    li {
      button {
        margin: 5px;
      }
    }
  }
`;

export const PoliciesMainContainer = styled.div`
  .policy-content {
    padding: 50px 0 30px;
    margin: 0 auto;
    color: ${(props) => props.theme.color.textLight};
    ${para1}
  }
  @media (max-width: 768px) {
    .policy-content {
      padding: 38px 0 20px;
    }
  }
`;

export const PostContainer = styled.ul`
  padding: 20px 0;
  display: flex;
  flex-wrap: wrap;

  &.mobile-container { display: none }
  li {
    margin: 30px 2% 0 0;
    flex-basis: 32%;
    h3 a {
      ${headLine4}
      color: ${(props) => props.theme.color.textLight};
    }
  }
  &.featured li:nth-child(3n + 2) {
    margin-right: ${(props) => (props.secondary ? null : "0")};
  }
  &.featured li:nth-child(3n + 3) {
    margin-right: ${(props) => (props.secondary ? "0" : null)};
  }
  &.normal li:nth-child(3n + 3) {
    margin-right: 0;
  }
  &.featured li:first-child, &.featured li:nth-child(2) {
    flex-basis: 48.9%;
    h3 a {
      ${headLine3}
    }
  }
  figure {
    div {
      width: 100%;
    }
    img {
      border: 1px solid rgba(0, 0, 0, 20%);
    }
  }
  @media (max-width: 995px) {
    justify-content: space-between;
    li {
      margin: 30px 0 0;
      flex-basis: 48%;
    }
    &.featured li:first-child { flex-basis: 100%; }
    &.featured li:nth-child(2) {
      h3 a {
        ${headLine4} 
      }
    }
  }
  @media (max-width: 768px) {
    &.mobile-container { display: block; }
    &.desktop-container { display: none; }
    li.sign-up-banner { margin: 20px 0 32px 0; }
  }
  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

export const PaginateContainer = styled.div`
  padding: 38px 0;
  @media (max-width: 768px) {
    padding: 5px 0 20px;
  }
`;

export const PolicyTagsPostContainer = styled.div`
  padding: 45px 0;
`;
